<template>
  <div id="publicSettingDiv">
    <div class="publicSettingDiv_content">
      <div class="head_title publicSetting_head_title">
        <div class="head_title_font publicSetting_head_title_font">信息设置</div>
      </div>
      <!--  <div class="query_div" style="margin: 10px 0px">
          <input type="text" class="form-control" style="display: inline-block;width: 200px" placeholder="标题" v-model="searchName">
          <button type="button" class="btn btn-default btn_option" @click="initDescriptionListData()">查询</button>
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal" @click="option_flag='add'">+ 新增</button>
        </div>-->

      <div class="body_content publicSetting_body_content">
       <!-- <div style="margin: 10px 0px">
          <input type="text" class="form-control" style="display: inline-block;width: 200px" placeholder="标题" v-model="searchName">
          <button type="button" class="btn btn-default btn_option" @click="initDescriptionListData()">查询</button>
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal" @click="option_flag='add'">+ 新增</button>
        </div>-->
        <div class="class_body_content_self">
          <table class="table table-striped table-bordered msgTb">
            <thead>
            <tr>
              <th width="30%">标题</th>
              <th width="30%">类型</th>
              <th width="30%">顺序</th>
              <th width="20%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(DescriptionList, index) in DescriptionList" :key="index">
              <td width="30%">{{DescriptionList.name}}</td>
              <td width="30%">{{DescriptionList.type | formatType}}</td>
              <td width="30%">{{DescriptionList.order}}</td>
              <td width="20%"  style="padding:8px 0 0 80px">
                <div class="edit_pic" @click="option_flag='update';updateMsgSetting(index)"></div>
                <!--<div class="delete_pic" @click="deleteDescription(DescriptionList.id)"></div>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <!-- 新增模态框（Modal） -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">
              {{option_flag=="add"?'新增':'编辑'}}
            </h4>
          </div>
          <div class="modal-body">
            <!--上传-->
            <uploader :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <p>拖拽文件至此处</p>
                <uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>
              </uploader-drop>
              <uploader-list></uploader-list>
            </uploader>

            <!--  <div class="editVideoDiv" v-if="option_flag == 'update' && isDeleteImage == false">
                <label>历史上传图片：</label>
                <p class="fileListP">
                  <a @click="openImageModal(description.filePath)">{{description.fileName}}</a>
                  <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile(description.attachmentId)"></span>
                </p>
              </div>-->
            <div class="editImageDiv" v-if="option_flag == 'update'">
              <label>历史上传附件：</label>
              <p class="fileListP" v-for="(att, index) in edit_current_file_data" :key="index">
                <a @click="openImageModal(att.filePath)">{{att.fileName}}</a>
                <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile(att.id)"></span>
              </p>
            </div>


            <br>
            <input type="text" class="form-control" v-validate="'required|maxL:50'" data-vv-scope="teachers" data-vv-as="标题" name="title" placeholder="标题" v-model="description.name">
            <span class="spanRed">*</span>
            <span class="validateTip">{{ errors.first('teachers.title') }}</span>
            <br>
            <select class="form-control" v-model="description.type">
              <option value="2">校内教师风采</option>
              <option value="1">党校介绍</option>
              <option value="3">校外教师风采</option>
            </select>
            <br>
            <textarea class="form-control description-textarea" placeholder="描述内容" v-model="description.content" style="resize: none"></textarea>
            <br>
            <input type="number" class="form-control" v-validate="'required'" data-vv-scope="teachers" data-vv-as="顺序" name="sorting" placeholder="顺序" v-model="description.order">
            <span class="spanRed">*</span>
            <span class="validateTip">{{ errors.first('teachers.sorting') }}</span>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="modalClickOk()">提交</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>

    <!--图片显示-->
    <div class="modal fade" id="myModal_showImage" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showImage" aria-hidden="true" data-backdrop='static'>
      <div class="modal-dialog modal-dialog-look">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              &times;
            </button>
            <h4 class="modal-title" id="myModalLabel_showImage">
              图片预览
            </h4>
          </div>
          <div class="modal-body modal-body-look">
            <img :src="description.filePath" class="previewImg"/>
          </div>
        </div>
      </div>
    </div>

    <!--修改信息模态框-->
    <!--   <div class="modal fade" id="updateDescriptionModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
         <div class="modal-dialog">
           <div class="modal-content">
             <div class="modal-header">
               <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
               <h4 class="modal-title" id="myModalLabel1">修改</h4>
             </div>
             <div class="modal-body">
               <div>
                 <label class="my_label">名称：</label>
                 <input id="updateName" v-validate="'required'" data-vv-scope="description" data-vv-as="名称" name="name" class="form-control" v-model="description.name" placeholder="输入名称">
               </div>
               <br>
               <div id="updateType">
                 <label class="my_label">类型：</label>
                 <select v-validate="'required'" data-vv-scope="description" data-vv-as="场地类型" name="type" class="form-control" v-model="description.type">
                   <option value="1">党校介绍</option>
                   <option value="2">校内教师风采</option>
                   <option value="3">校外教师风采</option>
                 </select>
               </div>
               <br>
               <label class="my_label">描述内容：</label>
               <textarea class="form-control" placeholder="描述内容" v-model="description.content" style="resize: none"></textarea>
               <br>
               <label class="my_label">顺序：</label>
               <input type="text" class="form-control" placeholder="顺序" v-model="description.order">
             </div>
             <div class="modal-footer">
               <button type="button" class="btn btn-primary" @click="update_Description()">提交</button>
               <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
             </div>
           </div>&lt;!&ndash; /.modal-content &ndash;&gt;
         </div>&lt;!&ndash; /.modal &ndash;&gt;
       </div>
     </div>-->
  </div>
</template>

<script>
  import {getContentSize} from './mainView';
  import {schoolAxios} from "../main"

  export default {
    name: "msgSetting",

    data() {
      return {
        DescriptionList:[],

        option_flag: '',

        isUploadImage: false,
        isDeleteImage:false,

        searchName: '',

        description: {
          id: '',
          name: '',
          type: '2',
          content: '',
          order: '',
          fileName: '',
          filePath: '',
          attachments: '',
        },

        //上传ID
        attachmentIds: '',
        edit_current_file_data: [],

        //上传
        uploadIds: '',
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'upload/upload.action',
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
            },
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 10*1024*1024*1024,//分片大小：10G
          },
          attrs: {
            image: {
              accept: 'image/*'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },
      }
    },
    filters: {
      formatType(value){
        let this_ = this;
        if(value == "1"){
          return '党校介绍';
        }else if(value == "2"){
          return "校内教师风采";
        }else {
          return "校外教师风采";
        }
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //刷新页面首次加载
        this_.initDescriptionListData();

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        this_.loadUpload();
      });
    },
    methods: {
      /**
       * 打开图片模态框
       */
      openImageModal(filePath) {
        let this_ = this;
        this_.description.filePath = this_.$store.state.serviceBase + "resources/" + filePath;
        $("#myModal_showImage").modal("show");
      },

      /**
       * 查询信息
       */
      initDescriptionListData() {
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'description/list',
          params: {
            type: 1,
            name: this_.searchName,
          },

        }).then(function (DescriptionListresp) {
          this_.DescriptionList = DescriptionListresp.data.list;
        });
      },
      modalClickOk(){
        let this_ = this;
        if(this_.option_flag == 'add'){
          this_.saveDescription();
        }else {
          this_.update_Description();
        }
      },
      saveDescription(){
        let this_ = this;
        /* let url = "";
           if(this_.option_flag == "add"){
             url = 'description/add';
           }else {
             url = 'description/edit';
           }*/
        this_.$validator.validateAll('teachers').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'description/add',
              data: {
                id: this_.description.id,
                name: this_.description.name,
                type: this_.description.type,
                content: this_.description.content,
                order: this_.description.order,
                // attachmentIds: this_.uploadIds,
                attachmentIds: this_.attachmentIds,
              }
            }).then(function (resp) {
              let data = resp.data;
              console.info(data);
              "保存成功".showMessage();
              $("#myModal").modal("hide");
              this_.initDescriptionListData();
            })
          }
        });
      },
      deleteDescription(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'description/delete',
            params: {
              id: id,
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initDescriptionListData();
            }else{
              "删除失败".showMessage();
            }
          });
        });
      },
      /**
       * 修改信息
       */
      updateMsgSetting(index){
        let this_ = this;

        let my_data = this_.DescriptionList[index];

        this_.description = {
          id: my_data.id,
          name: my_data.name,
          type: my_data.type,
          content: my_data.content,
          order: my_data.order,
          filePath:my_data.filePath,
          fileName: my_data.fileName
        };
        // this_.uploadIds =this_.uploadIds,

        this_.edit_current_file_data = my_data.attachments;

        $("#myModal").modal('show');

        //组装附件ID
        /* this_.splitAttachmentIds(my_data.attachmentId);
         let attachments = my_data.attachments;
         for(let i=0; i<attachments.length; i++){
           this_.splitAttachmentIds(attachments[i].id);
         }*/
      },

      deleteAttachmentsFile(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.isUploadImage = false;
              this_.isDeleteImage = true;
              // this_.upload.uploaderImage.cancel();
              let index = -1;
              for(let i=0; i<this_.edit_current_file_data.length; i++){
                if(this_.edit_current_file_data[i].id == id){
                  index = i;
                }
              }
              if(index >= 0){
                this_.edit_current_file_data.splice(index, 1);
              }
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },

      /**
       * 拼接附件ID
       */
      splitAttachmentIds(attachmentIds){
        let this_ = this;
        if(this_.attachmentIds != ""){
          this_.attachmentIds += ",";
        }
        this_.attachmentIds += attachmentIds;
      },

      /**
       * 修改信息
       */
      update_Description(index){
        let this_ = this;
        let attachments = this_.edit_current_file_data;
        for(let i=0; i<attachments.length; i++){
          this_.splitAttachmentIds(attachments[i].id);
        }
        this_.$validator.validateAll('teachers').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'description/edit',
              data: {
                'id': this_.description.id,
                'name': this_.description.name,
                'type': this_.description.type,
                'content': this_.description.content,
                'order': this_.description.order,
                // 'attachmentIds': this_.uploadIds,
                'attachmentIds': this_.attachmentIds,
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "修改成功".showMessage();
                this_.isAddTeacher = false;
                this_.initDescriptionListData();
                $("#myModal").modal('hide');
              } else {
                data.message.showMessage();
              }
            });
          }
        });
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.description = {
            id: '',
            name: '',
            type: '2',
            content: '',
            order: '',
            filePath:'',
            fileName:'',
            attachments:'',
          };
          // this_.uploadIds = "";
          this_.upload.uploader.cancel();

          this_.attachmentIds = "";
        });
        $("#myModal_showImage").modal('hide');
        /*  $("#updateDescriptionModal").on('hide.bs.modal', function () {
            this_.description.name = '';
            this_.description.type = '';
            this_.description.content = '';
            this_.description.order = '';
          });*/
      },
      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          if(file.fileType.indexOf("image")==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          //console.info(message);
          if(message){
            let message_ = JSON.parse(message);
            if(this_.uploadIds != ""){
              this_.uploadIds += ",";
            }
            this_.uploadIds += message_.message;
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          //console.info(rootFile);
        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },
    },
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/msgSetting.css";

</style>



// WEBPACK FOOTER //
// src/components/msgSetting.vue